export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewSupplier(state, { payload }) {
    state.suppliers = [...state.suppliers, ...[payload]];
  },

  delProperty(state, { property }) {
    state.suppliers = state.suppliers.filter(el => el.id !== property);
  },
};
